<template>
  <div>
    <div id="random-archives" class="container">

      <div class="random-archives-title-wrapper">
        <h4 class="random-archives-title">RANDOM ARCHIVES</h4>
      </div>

      <router-link class="video"
                   v-for="v in videos"
                   :key="v.ytid"
                   :to="{name: 'video-player', params: {ytid: v.ytid }}"
                   :style="{ 'background-image': 'url(' + v.thumbnail + ')' }">
        <div class="overlay">
          <div class="caption">
            <div class="title-bg"><h4 class="title">{{ v.title }}</h4></div>
            <div class="note-bg"><p class="note">{{ v.note }}</p></div>
          </div>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
  import thisismApi from '../api/thisism-api'

  export default {
    data () {
      return {
        videos: {}
      }
    },
    methods: {},
    created () {
      thisismApi.getRandomVideos(9).then(data => {
        this.videos = data
      })
    }
  }

</script>
<style lang="scss" scoped>

  @import "../style/common";

  .container {
    margin: 20px 0;
    padding: 0;
    width: 100%;
  }

  .random-archives-title-wrapper {
    display: block;
    margin: 30px 0 20px;
  }

  .random-archives-title {
    display: inline;
    padding: 5px 20px;
    background-color: white;
    color: black;
    font-size: 2.6rem;
  }

  .video {

    //skeltonのcolumnの代替えでfloatをかける
    float: left;
    box-sizing: border-box;

    //captionの位置を指定したいから
    position: relative;

    height: 150px;
    width: 50%;

    background-position: center;
    background-size: cover;

    &:hover .overlay {
      opacity: 1;
    }
  }

  .overlay {
    height: 100%;
    width: 100%;

    background: rgba(0, 0, 0, .7);
    -webkit-transition: .6s;
    transition: .6s;
    opacity: 0;

  }

  .caption {

    //絶対値の位置指定
    /*position: absolute;*/
    /*top: 2rem;*/

    //color: $color_white;
    /*width: 100%;*/
    margin: 0;
    padding: 1rem;
    z-index: 5;
  }

  .title-bg {
    text-align: center;
  }

  .title {
    font-size: 1.3rem;
  }

  .note-bg {
    text-align: left;
  }

  .note {
    font-size: 0.1rem;
  }

  /* Larger than phablet */
  @media (min-width: 550px) {

    .container {
      margin: 0 auto;
      padding: 0;
    }

    .video {
      width: 33.33%;
      height: 200px;
    }

    .title {
      font-size: 1.5rem;
    }

    .note {
      font-size: 1rem;
    }
  }

</style>



// WEBPACK FOOTER //
// RandomArchives.vue?0a448750